module.exports = __webpack_public_path__ + "static/media/bg.74b77897.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/bg.png
// module id = 1733
// module chunks = 0 1